import { render, staticRenderFns } from "./SCR_MBC_0115_01.vue?vue&type=template&id=2f70b062&scoped=true&"
import script from "./SCR_MBC_0115_01.vue?vue&type=script&lang=js&"
export * from "./SCR_MBC_0115_01.vue?vue&type=script&lang=js&"
import style0 from "./SCR_MBC_0115_01.vue?vue&type=style&index=0&id=2f70b062&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f70b062",
  null
  
)

export default component.exports